export const colors = {
	1: '#37ECAB',
	2: '#FCBFE3',
	3: '#FFCF55',
	4: '#5BC57F',
	5: '#3918FF',
	6: '#F7CA45',
	7: '#5D54D5',
	8: '#EE7F4C',
	9: '#57A7DB',
   10: '#F095C7',
};
